import {API} from 'aws-amplify'
import {apiCallWithAuthCheck} from '../auth/core/AuthErrorInterceptor'
import {CatalogModule, PurchaseCurrency, RECHARGE_SKU, RenewYears} from './catalog'
import {QuotePurchaseKind} from './QuoteRequestDialog'

const apiName: string = process.env.REACT_APP_API_NAME || 'JobService'

export interface CheckoutSessionResponse {
  url: string
  session_id: string
  subscription_id: string
}

export interface QuoteRequestPayload {
  kind: QuotePurchaseKind | 'recharge'
  modules?: CatalogModule[]
  seats?: number
  packs?: number
  renew_years?: RenewYears
  request_renewal_period?: boolean
  request_extra_seats?: boolean
  request_extra_modules?: boolean
  comments?: string
}

export const createRechargeCheckout = async (
  currency: PurchaseCurrency,
  quantity: number,
  attemptId: string
): Promise<CheckoutSessionResponse> => {
  return apiCallWithAuthCheck(async () => {
    return API.post(apiName, 'v1/checkout/sessions', {
      body: {
        kind: 'recharge',
        sku: RECHARGE_SKU,
        currency,
        quantity,
        attempt_id: attemptId,
      },
    })
  })
}

export const submitQuoteRequest = async (payload: QuoteRequestPayload): Promise<void> => {
  return apiCallWithAuthCheck(async () => {
    await API.post(apiName, 'v1/quote-requests', {body: payload})
  })
}
